<template>
  <div class="centered-container">
    <div class="external-layout">
      <div class="gap-title">
        <div style="margin: 20px 0; padding-left: 20px;">
          <h3 style="margin: 0; padding-bottom: 2.5rem;"><strong>{{ $t("enlaceExternoTurnosOperariosTitle") + businessName }}</strong></h3>
        </div>
      </div>
      <!-- <CabeceraInformes
        v-show="false"
        :idBusiness="idBusiness"
        :listBusinesses="listBusinesses"
        :idTpv="idTpv"
        :listTpv="listTpv"
        :dateto="dateto"
        :datefrom="datefrom"
        id="cabecera"
        :conTodos="true"
        :conFiltrarPorFecha="true"
      /> -->
      <!-- 
      <template v-if="!permiso">
        <div class="alert alert-danger m-3" style="width: 100%" role="alert">
            Lo sentimos. Este negocio no cuenta con este módulo activado.
        </div>
      </template>
-->
      <template v-if="respuesta">
        <div>
          <template v-if="list.length > 0 && !mostrarTurnos">
            <div class="table-responsive">
              <table class="table table-bordered table-striped text-nowrap">
                <thead class="thead-dark">
                  <tr style="cursor: pointer">
                    <th v-if="ordenacionOperario === 0" @click="sortedArrayNameASC('workerName')">
                      <i style="color: white" class="fa fa-angle-up"></i>
                      {{ $t("nombre") }}
                    </th>
                    <th v-else @click="sortedArrayNameDESC('workerName')">
                      <i style="color: white" class="fa fa-angle-down"></i>
                      {{ $t("nombre") }}
                    </th>
                    <th v-if="ordenarDifHora === 0" @click="sortedArrayDifHoraASC('diffHora')">
                      <i style="color: white" class="fa fa-angle-up"></i>
                      {{ $t("horas") }}
                    </th>
                    <th v-else @click="sortedArrayDifHoraDESC('diffHora')">
                      <i style="color: white" class="fa fa-angle-down"></i>
                      {{ $t("horas") }}
                    </th>
                    <th>{{ $t("acciones") }}</th>
                  </tr>
                </thead>

                <tbody>
                  <tr v-for="obj in list">
                    <td>{{ obj.name }}</td>
                    <td>{{ obj.diffHora | timago }}</td>
                    <td align="center">
                      <div class="btn btn-link">
                        <i v-if="obj.diffHora !== 0" @click="turnosOperarios(obj.idWorker)"
                          class="fas fa-arrow-circle-right" style="cursor: pointer" v-tooltip.top-center="$i18n.t('desgloseHorasTrabajadas')
                            "></i>
                      </div>
                    </td>
                  </tr>
                </tbody>

                <tfoot>
                  <tr class="table-success">
                    <td>
                      <strong>{{ $t("total") }}</strong>
                    </td>
                    <td>
                      <strong v-if="getTotalHoras !== 0">{{
                        getTotalHoras | timago
                        }}</strong>
                    </td>
                    <td></td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </template>
          <template v-else-if="mostrarTurnos">
            <div class="col-md-12">
              <div class="row mb-2">
                <div class="col-md-12 text-left">
                  <button @click="volver()" class="btn btn-primary btn-sm rs-btn">
                    <i class="fas fa-arrow-circle-left"></i>
                    {{ $t("volverAGeneral") }}
                  </button>
                </div>
              </div>

              <span style="font-size: 1.2em" v-if="listTurnos.length != 0">
                {{ $t("turnosDe") }} {{ listTurnos[0].name }}</span>
            </div>
            <div class="col-md-12">
              <div class="table-responsive">
                <table class="table table-bordered table-striped">
                  <thead class="thead-dark">
                    <tr>
                      <th>{{ $t("horaInicio") }}</th>
                      <th>{{ $t("horaFin") }}</th>
                      <th>{{ $t("horasTrabajadas") }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="t in listTurnos">
                      <td>{{ t.initDate | parseDateMin }}</td>
                      <td v-if="parseInt(t.endDate) === 0" class="text-success">
                        <strong>{{ $t("enActivo") }}</strong>
                      </td>
                      <td v-else>{{ t.endDate | parseDateMin }}</td>
                      <td>{{ t.diffHora | timago }}</td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr class="table-success">
                      <td>
                        <strong>{{ $t("total") }}</strong>
                      </td>
                      <td></td>
                      <td>
                        <strong v-if="getTotalHoras !== 0">{{
                          getTotalHorasWorker | timago
                          }}</strong>
                      </td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="alert alert-danger" role="alert">
              <strong>{{ $t("noHayTurnosDeOperarioParaMostrar") }}</strong>
              {{ $t("rangoDeFechas") }}
            </div>
          </template>
        </div>
      </template>
    </div>

    <!--
    <modal
      name="modal-agregar-observacion"
      :adaptive="true"
      :scrollable="true"
      height="auto"
      :clickToClose="true"
    >
      <div>
        <div class="modal-header">
          <h4 style="margin: 0px">{{ $t("anadirObservacion") }}</h4>
        </div>
        <div class="modal-body">
          <label for="observacion"
            ><strong>{{ $t("observaciones") }}</strong></label
          >
          <textarea
            style="height: 300px"
            v-model="observacion"
            class="form-control"
            id="observacion"
          >
          </textarea>
        </div>
        <div class="modal-footer">
          <div align="right" class="col-12">
            <button @click="changeObservaciones" class="btn btn-success">
              <i class="fas fa-plus-circle"></i>
              {{ $t("anadirObservacion") }}
            </button>
          </div>
        </div>
      </div>
    </modal>

    <modal
      name="modal-editar-horario"
      :adaptive="true"
      :scrollable="true"
      height="auto"
      :clickToClose="true"
    >
      <div>
        <div class="modal-header">
          <h4 style="margin: 0px">{{ $t("editarHorario") }}</h4>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <label
              ><strong>{{ $t("fechaInicio") }}</strong></label
            >
            <datetime
              zone="Europe/Madrid"
              :auto="true"
              type="datetime"
              class="theme-numier"
              :title="$t('fechaInicio')"
              :phrases="{ ok: $t('aceptar'), cancel: $t('salir') }"
              input-class="form-control"
              format="dd-MM-yyyy HH:mm"
              v-model="fechaInicio"
            ></datetime>
          </div>

          <div class="form-group">
            <label
              ><strong>{{ $t("fechaFin") }}</strong></label
            >
            <datetime
              zone="Europe/Madrid"
              :auto="true"
              type="datetime"
              class="theme-numier"
              :title="$t('fechaFin')"
              :phrases="{ ok: $t('aceptar'), cancel: $t('salir') }"
              input-class="form-control"
              format="dd-MM-yyyy HH:mm"
              v-model="fechaFin"
            ></datetime>
          </div>
        </div>
        <div class="modal-footer">
          <div align="right" class="col-12">
            <button @click="changeHorarioTurno" class="btn btn-primary">
              <i class="fas fa-history"></i>
              {{ $t("editarHorarioDeTurno") }}
            </button>
          </div>
        </div>
      </div>
    </modal>
-->

  </div>
</template>

<script>
import CabeceraInformes from "@/components/CabeceraInformes/CabeceraInformes.vue";
import Chart from "chart.js";
import {
  DatePicker,
  Select,
  Option,
  Loading,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Button,
} from "element-ui";
import swal from "sweetalert2";
import moment from "moment";
import Breadcrumb from "../../../../components/Breadcrumb/Breadcrumb.vue";
import { mapState } from 'vuex'
import { Modal } from "bootstrap";
import { ModalPlugin } from "bootstrap-vue";


export default {
  props: ['hash'],
  data() {
    return {
      loading: false,
      datefrom: new Date(
        new Date().getFullYear(),
        new Date().getMonth(),
        1
      ).toISOString(),
      dateto: new Date().toISOString(),
      listBusinesses: [],
      value4: [
        new Date(new Date().getFullYear(), new Date().getMonth(), 1),
        new Date(),
      ],
      idBusiness: 0,
      list: ["-"],
      mode: 0,
      $Chart: null,
      objectChart: null,
      contador: 0,
      chartIn: 0,
      listTpv: [],
      idTpv: 0,
      dateRangeOptions1: {
        firstDayOfWeek: 1,
      },

      ordenacionOperario: 0,
      ordenarImporte: 0,
      ordenarInvitations: 0,
      ordenarDifHora: 0,
      ordenarSueldo: 0,

      observacion: "",

      //TURNOS
      mostrarTurnos: false,
      listTurnos: [],
      idWorker: 0,

      idWorkerDay: 0,
      respuesta: true,
      filtrarPorFecha: false,

      fechaInicio: new Date().toISOString(),
      fechaFin: new Date().toISOString(),

      idBusinessByHash: null,
      idTpvByHash: null,
      createdDateByHash: null,
      isLinkExpired: false,
      businessName: ""
    };
  },
  computed: {
    ...mapState(["permiso"]),
    getTotalSueldos() {
      let total = 0;
      this.list.forEach(function (d) {
        if (d.import > 0) {
          total += d.import * (d.diffHora / 60);
        }
      });
      return total;
    },
    getTotalHoras() {
      let total = 0;
      this.list.forEach(function (d) {
        total += d.diffHora;
      });
      return total;
    },
    getTotalHorasWorker() {
      let total = 0;
      this.listTurnos.forEach(function (d) {
        total += d.diffHora;
      });
      return total;
    },
    /*
    getTotalSueldosWorker() {
      var total = 0;
      this.listTurnos.forEach(function(d) {
        if (d.import > 0) {
          total += d.import;
        }
      });
      return total;
    },
    urlExportPDF() {
      return (
        this.$store.getters.apiUrl +
        "/workers/exportTurnosWorkers/PDF?idTpv=" + 
        this.idTpv +
        "&idBusiness=" +
        this.idBusiness +
        "&datefrom=" +
        moment(this.datefrom)
          .startOf("day")
          .unix() +
        "&dateto=" +
        moment(this.dateto)
          .endOf("day")
          .unix() +
        "&filtrarPorFecha="+
        this.filtrarPorFecha+ 
        "&jwt=" +
        this.$store.getters.jwt
      );
    },
    urlExportExcel() {
      return (
        this.$store.getters.apiUrl +
        "/workers/exportTurnosWorkers/Excel?idTpv=" + 
        this.idTpv + 
        "&idBusiness=" +
        this.idBusiness +
        "&datefrom=" +
        moment(this.datefrom)
          .startOf("day")
          .unix() +
        "&dateto=" +
        moment(this.dateto)
          .endOf("day")
          .unix() +
        "&filtrarPorFecha="+
        this.filtrarPorFecha+ 
        "&jwt=" +
        this.$store.getters.jwt
      );
    },

    urlExportPDFById() {
      return (
        this.$store.getters.apiUrl +
        "/workers/exportTurnosWorkersById/PDF?idBusiness=" +
        this.idBusiness +
        "&idTpv=" +
        this.idTpv +
        "&idWorker=" +
        this.idWorker +
        "&datefrom=" +
        moment(this.datefrom)
          .startOf("day")
          .unix() +
        "&dateto=" +
        moment(this.dateto)
          .endOf("day")
          .unix() +
        "&filtrarPorFecha="+
        this.filtrarPorFecha+ 
        "&jwt=" +
        this.$store.getters.jwt
      );
    },
    urlExportExcelById() {
      return (
        this.$store.getters.apiUrl +
        "/workers/exportTurnosWorkersById/Excel?idBusiness=" +
        this.idBusiness +
        "&idTpv=" +
        this.idTpv +
        "&idWorker=" +
        this.idWorker +
        "&datefrom=" +
        moment(this.datefrom)
          .startOf("day")
          .unix() +
        "&dateto=" +
        moment(this.dateto)
          .endOf("day")
          .unix() +
        "&filtrarPorFecha="+
        this.filtrarPorFecha+ 
        "&jwt=" +
        this.$store.getters.jwt
      );
    },
    */
  },
  created() {
    this.$store.dispatch("setNameRoute", this.$i18n.t("turnosDeOperarios"));
    this.getTurnosOperariosByHash();

    if (this.$store.getters.dateTo && this.$store.getters.dateFrom) {
      this.datefrom = this.$store.getters.dateFrom;
      this.dateto = this.$store.getters.dateTo;
    }
  },
  mounted() {
  },
  components: {
    CabeceraInformes,
    Breadcrumb,
    [DatePicker.name]: DatePicker,
    [Select.name]: Select,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Button.name]: Button,
    [Option.name]: Option,
  },
  methods: {
    /*
    cambioBusiness(idBusinessData, listTpv = null) {
      this.idBusiness = idBusinessData;
      if (listTpv) {
        this.listTpv = listTpv;
      }
      this.idTpv = -1;
      this.listTurnos = [];
      this.mostrarTurnos = false;
    },
    */
    /*
      emitirConsulta(filtrarPorFecha) {
        this.getSalesOperarios(filtrarPorFecha);
      },
      */
    /*
    cambioTpv(idTpvData, filtrarPorFecha) {
      this.idTpv = idTpvData;

      if (this.idWorker != 0 && this.mostrarTurnos == true) {
        //this.turnosOperarios(this.idWorker);
        this.mostrarTurnos = false;
      }
      this.getSalesOperarios(filtrarPorFecha);
    },
    */

    /*
    cambioHora(dates) {
      this.datefrom = dates[0];
      this.dateto = dates[1];
    },
    */
    sortedArrayWorkerDay: function () {
      function compare(a, b) {
        if (a.initDate < b.initDate) return -1;
        if (a.initDate > b.initDate) return 1;
        return 0;
      }

      return this.listTurnos.sort(compare);
    },

    /*
    openModal(idWorkerDay) {
      this.$modal.show("modal-agregar-observacion");

      this.idWorkerDay = idWorkerDay;
    },
    */

    /*
    openModalEditarHora(idWorkerDay, initDate, endDate) {
      this.$modal.show("modal-editar-horario");

      this.idWorkerDay = idWorkerDay;

      this.fechaInicio = moment.unix(initDate).toISOString();

      if (endDate !== "0") {
        this.fechaFin = moment.unix(endDate).toISOString();
      } else {
        this.fechaFin = newDate().toIsoString();
      }
    },
    */

    sortedArrayNameASC: function () {
      this.ordenacionOperario = 1;

      function compare(a, b) {
        if (a.name < b.name) return -1;
        if (a.name > b.name) return 1;
        return 0;
      }

      return this.list.sort(compare);
    },
    sortedArrayNameDESC: function () {
      this.ordenacionOperario = 0;

      function compare(a, b) {
        if (a.name > b.name) return -1;
        if (a.name < b.name) return 1;
        return 0;
      }

      return this.list.sort(compare);
    },

    sortedArrayDifHoraASC: function () {
      this.ordenarDifHora = 1;

      function compare(a, b) {
        if (a.diffHora < b.diffHora) return -1;
        if (a.diffHora > b.diffHora) return 1;
        return 0;
      }

      return this.list.sort(compare);
    },
    sortedArrayDifHoraDESC: function () {
      this.ordenarDifHora = 0;

      function compare(a, b) {
        if (a.diffHora > b.diffHora) return -1;
        if (a.diffHora < b.diffHora) return 1;
        return 0;
      }

      return this.list.sort(compare);
    },

    /*
    sortedArraySueldoASC: function() {
      this.ordenarSueldo = 1;

      function compare(a, b) {
        if (a.import < b.import) return -1;
        if (a.import > b.import) return 1;
        return 0;
      }

      return this.list.sort(compare);
    },
    sortedArraySueldoDESC: function() {
      this.ordenarSueldo = 0;

      function compare(a, b) {
        if (a.import > b.import) return -1;
        if (a.import < b.import) return 1;
        return 0;
      }

      return this.list.sort(compare);
    },
    */

    turnosOperarios(idWorker) {
      console.log("el idBusiness es " + this.idBusiness);
      console.log("el idTpv es " + this.idTpv);


      this.idWorker = idWorker;

      this.mostrarTurnos = true;

      if (this.datefrom === null || this.dateto === null) {
        swal({
          title: this.$t("ups"),
          text: this.$t("seleccioneUnaFechaDeInicioYUnaFechaDeFin"),
          confirmButtonClass: "btn btn-info btn-fill",
          type: "error",
        });
      } else {
        let secondsDesde = moment(this.datefrom).unix();
        let secondsHasta = moment(this.dateto).unix();

        if (secondsHasta < secondsDesde) {
          swal({
            title: this.$t("ups"),
            text: this.$t("laFechaDeInicioNoPuedeSerPosteriorALaDeFin"),
            confirmButtonClass: "btn btn-info btn-fill",
            type: "error",
          });
        } else {
          this.loading = Loading.service({ text: "Cargando..." });

          this.$store.dispatch("setDateTo", this.dateto);
          this.$store.dispatch("setDateFrom", this.datefrom);

          var config = {
            params: {
              idTpv: this.idTpv,
              idBusiness: this.idBusiness,
              idWorker: idWorker,
              datefrom: moment(this.datefrom)
                .startOf("day")
                .unix(),
              dateto: moment(this.dateto)
                .endOf("day")
                .unix(),
              //jwt: this.$store.getters.jwt,
              filtrarFecha: this.filtrarPorFecha
            },
            // headers: { Authorization: "Bearer " + this.$store.getters.jwt },
          };

          let vm = this;
          this.$store.dispatch("setIdBusiness", this.idBusiness);
          this.axios
            .get(this.$store.getters.apiUrl + "externalLink/getWorkersDayByHash", config)
            .then(function (response) {
              if (response.data.response) {
                console.log("tengo respuesta: " + response.data.result);
                vm.listTurnos = response.data.result;

                vm.sortedArrayWorkerDay();
              } else {
                swal({
                  title: vm.$t("accesoDenegado"),
                  text: response.data.message,
                  confirmButtonClass: "btn btn-info btn-fill",
                  type: "error",
                });
              }
              vm.loading.close();
            })
            .catch(function (error) {
              console.log(error);
            });

          vm.sortedArrayWorkerDay();

        }
      }
    },

    /*
    changeNegocio() {},
    */
    volver() {
      this.listTurnos = [];
      this.mostrarTurnos = false;
    },

    /*
    getBusiness() {
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "externalLink/getBusinessesByUser", config)
        .then(function(response) {

          // Si tenemos valor para idBusiness, vamos a filtrar, de todos los negocios del usuario que hemos obtenido al hacer getBusinessesByUser, me 
          // deje en mi lista de businesses solo aquel cuyo id es igual a mi vm.idBusiness
          if (vm.idBusiness) {
            const filteredBusiness = response.data.result.find(
              (business) => business.id === vm.idBusiness
            );
            vm.businessName = filteredBusiness
              ? filteredBusiness.establishmentName
              : null;
            vm.listBusinesses = filteredBusiness ? [filteredBusiness] : [];
          
          } else {
            // Si no hay un idBusiness definido, usar el primero como predeterminado
            const firstBusiness = response.data.result[0] || null;
            vm.businessName = firstBusiness ? firstBusiness.establishmentName : null;
            vm.listBusinesses = firstBusiness ? [firstBusiness] : [];
            vm.idBusiness = firstBusiness ? firstBusiness.id : null;
          }
          
          vm.cambioTpv(vm.idTpvByHash, false);
          vm.filterTpvListByIdTpv();
        })
        .catch(function(error) {
          console.log(error);
        })
        .finally((_) => {
          this.loading.close();
        });
    },
    */
    /*
    getSalesOperarios(filtrarPorFecha) {
      if (this.datefrom === null || this.dateto === null) {
        swal({
          title: this.$t("ups"),
          text: this.$t("seleccioneUnaFechaDeInicioYUnaFechaDeFin"),
          confirmButtonClass: "btn btn-info btn-fill",
          type: "error",
        });
      } else {
        let secondsDesde = moment(this.datefrom).unix();
        let secondsHasta = moment(this.dateto).unix();

        if (secondsHasta < secondsDesde) {
          swal({
            title: this.$t("ups"),
            text: this.$t("laFechaDeInicioNoPuedeSerPosteriorALaDeFin"),
            confirmButtonClass: "btn btn-info btn-fill",
            type: "error",
          });
        } else {
          this.loading = Loading.service({ text: "Cargando..." });

          this.$store.dispatch("setDateTo", this.dateto);
          this.$store.dispatch("setDateFrom", this.datefrom);

          var config = {
            params: {
              idBusiness: this.idBusiness,
              idTpv: this.idTpv,
              filtrarPorFecha:filtrarPorFecha,
              datefrom: moment(this.datefrom)
                .startOf("day")
                .unix(),
              dateto: moment(this.dateto)
                .endOf("day")
                .unix(),
              jwt: this.$store.getters.jwt,
              desde: 0,
            },
            headers: { Authorization: "Bearer " + this.$store.getters.jwt },
          };

          let vm = this;
          this.$store.dispatch("setIdBusiness", this.idBusiness);
          this.axios
            .get(
              this.$store.getters.apiUrl + "externalLink/getTurnosOperarios",
              config
            )
            .then(function(response) {
              if (response.data.response) {
                vm.list = response.data.result;

                vm.respuesta = true;
                vm.filtrarPorFecha = filtrarPorFecha;

                vm.initChart();
              } else {
                swal({
                  title: vm.$t("accesoDenegadorrr"),
                  text: response.data.message,
                  confirmButtonClass: "btn btn-info btn-fill",
                  type: "error",
                });

                vm.respuesta = false;
              }
              vm.loading.close();
            })
            .catch(function(error) {
              console.log(error);
            });
        }
      }
    },

    */
    /*
    changeObservaciones() {
      var config = {
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
        params: {
          jwt: this.$store.getters.jwt,
        },
      };
      var params = {
        observaciones: this.observacion,
        idWorkerDay: this.idWorkerDay,
        jwt: this.$store.getters.jwt,
      };

      let vm = this;
      let controller = "updateObservacionesByIdWorkerDay";
      this.axios
        .post(
          this.$store.getters.apiUrl + "workers/" + controller,
          params,
          config
        )
        .then(function(response) {
          vm.inProgress = false;

          if (response.data.response) {
            let notify = vm.$t("actualizada");
            vm.$notify({
              message:
                vm.$t("observacion") +
                " " +
                notify +
                " " +
                vm.$t("correctamente"),
              icon: "nc-icon nc-check-2",
              timeout: 2000,
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "success",
            });

            vm.turnosOperarios(vm.idWorker);

            vm.$modal.hide("modal-agregar-observacion");
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        })
        .catch(function(error) {
          console.log(error);
          vm.inProgress = false;
        });
    },

    changeHorarioTurno() {
      let secondsDesde = moment(this.fechaInicio).unix();
      let secondsHasta = moment(this.fechaFin).unix();

      if (secondsHasta < secondsDesde) {
        swal({
          title: this.$t("ups"),
          text: this.$t("laFechaDeInicioNoPuedeSerPosteriorALaDeFin"),
          confirmButtonClass: "btn btn-info btn-fill",
          type: "error",
        });
      } else {
        var config = {
          headers: { Authorization: "Bearer " + this.$store.getters.jwt },
          params: {
            jwt: this.$store.getters.jwt,
          },
        };
        var params = {
          datefrom: secondsHasta,
          dateto: secondsDesde,
          idWorkerDay: this.idWorkerDay,
          jwt: this.$store.getters.jwt,
        };

        let vm = this;
        let controller = "updateHorarioByIdWorkerDay";
        this.axios
          .post(
            this.$store.getters.apiUrl + "workers/" + controller,
            params,
            config
          )
          .then(function(response) {
            vm.inProgress = false;

            if (response.data.response) {
              let notify = vm.$t("actualizada");
              vm.$notify({
                message:
                  vm.$t("observacion") +
                  " " +
                  notify +
                  " " +
                  vm.$t("correctamente"),
                icon: "nc-icon nc-check-2",
                timeout: 2000,
                horizontalAlign: "right",
                verticalAlign: "top",
                type: "success",
              });

              vm.turnosOperarios(vm.idWorker);

              vm.$modal.hide("modal-editar-horario");
            } else {
              swal({
                title: vm.$t("atencion"),
                text: response.data.message,
                confirmButtonClass: "btn btn-info btn-fill",
                type: "error",
              });
            }
          })
          .catch(function(error) {
            console.log(error);
            vm.inProgress = false;
          });
      }
    },

    exportGestionTurnosOperariosExcel(idWorker) {
      // window.location.href = "../api/public/index.php/workers/exportRegistroHorarioByBusiness/Excel?idBusiness=" + this.idBusiness + "&datefrom=" + moment(this.datefrom).startOf("day").unix() + "&idWorker=" + idWorker + "&dateto=" + moment(this.dateto).endOf("day").unix() + "&jwt=" + this.$store.getters.jwt;

      window.location.href =
        this.$store.getters.apiUrl +
        "/workers/exportRegistroHorarioByBusiness/Excel?idBusiness=" +
        this.idBusiness +
        "&idTpv=" + 
        this.idTpv +
        "&datefrom=" +
        moment(this.datefrom)
          .startOf("day")
          .unix() +
        "&idWorker=" +
        idWorker +
        "&dateto=" +
        moment(this.dateto)
          .endOf("day")
          .unix() +
        "&jwt=" +
        this.$store.getters.jwt;
    },
    exportGestionTurnosOperariosPDF(idWorker) {
      window.location.href =
        this.$store.getters.apiUrl +
        "/workers/exportRegistroHorarioByBusiness/PDF?idBusiness=" +
        this.idBusiness +
        "&datefrom=" +
        moment(this.datefrom)
          .startOf("day")
          .unix() +
        "&idWorker=" +
        idWorker +
        "&dateto=" +
        moment(this.dateto)
          .endOf("day")
          .unix() +
        "&jwt=" +
        this.$store.getters.jwt;
    },

    initChart() {
      var labels = this.list.map(function(x) {
        return x.name;
      });

      var data = this.list.map(function(x) {
        var hours = Math.floor(x.diffHora / 60);
        var minutes = Math.floor(x.diffHora % 60);

        return hours + minutes / 100;
      });

      var randomColor = require("randomcolor");

      var colors = randomColor({
        luminosity: "dark",
        count: labels.length,
        format: "rgb",
      });

      let backgroundColors = colors.map(function(x) {
        let xcolors = x.substring(x.indexOf("(") + 1, x.length - 1).split(",");
        return (
          "rgba(" + xcolors[0] + "," + xcolors[1] + "," + xcolors[2] + ", 0.6)"
        );
      });

      let borderColors = colors.map(function(x) {
        let xcolors = x.substring(x.indexOf("(") + 1, x.length - 1).split(",");
        return (
          "rgba(" + xcolors[0] + "," + xcolors[1] + "," + xcolors[2] + ", 0.3)"
        );
      });

      let hoverBackgroundColors = colors.map(function(x) {
        let xcolors = x.substring(x.indexOf("(") + 1, x.length - 1).split(",");
        return (
          "rgba(" + xcolors[0] + "," + xcolors[1] + "," + xcolors[2] + ", 1)"
        );
      });

      if (this.contador === 0) {
        if (this.list.length > 0) {
          this.objectChart = new Chart("chart", {
            type: "bar",
            data: {
              labels: labels,
              datasets: [
                {
                  label: this.$t("horasTrabajadas"),
                  data: data,
                  backgroundColor: backgroundColors,
                  borderColor: borderColors,
                  hoverBackgroundColor: hoverBackgroundColors,
                  borderWidth: 1,
                },
              ],
            },
            options: {
              scales: {
                yAxes: [
                  {
                    ticks: {
                      beginAtZero: true,
                    },
                  },
                ],
              },

              responsive: true,
              maintainAspectRatio: false,
            },
          });

          this.contador++;
        }
      } else {
        this.objectChart.destroy();

        this.objectChart = new Chart("chart", {
          type: "bar",
          data: {
            labels: labels,
            datasets: [
              {
                data: data,
                label: this.$t("turnosOperarios"),
                backgroundColor: backgroundColors,
                borderColor: borderColors,
                hoverBackgroundColor: hoverBackgroundColors,
                borderWidth: 1,
              },
            ],
          },
          options: {
            scales: {
              yAxes: [
                {
                  ticks: {
                    beginAtZero: true,
                  },
                },
              ],
            },
            responsive: true,
            maintainAspectRatio: false,
          },
        });
      }
    },
    */
    getTurnosOperariosByHash() {

      if (!this.hash) {
        console.error("Hash no definido o inválido. No se puede realizar la petición.");
        return;
      }

      const config = {
        params: {
          hash: this.hash,
          //jwt: this.$store.getters.jwt 
        },
        //headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;

      this.axios
        .get(this.$store.getters.apiUrl + "externalLink/getTurnosOperariosByHash", config)
        .then(function (response) {
          if (response.data.response) {

            // Asignamos los turnos que vienen en el result a la lista, el businessName para usarlo en el título y la fecha de creacion para el checkLinkExpiration
            vm.list = response.data.result;
            vm.idBusiness = response.data.idBusiness;
            vm.idTpv = response.data.idTpv;
            vm.businessName = response.data.businessName;
            vm.createdDateByHash = response.data.createdDate;
            vm.datefrom = moment.unix(response.data.initDate).format("YYYY-MM-DDTHH:mm:ss.SSSZ");
            vm.dateto = moment.unix(response.data.endDate).format("YYYY-MM-DDTHH:mm:ss.SSSZ");

            var listaTurnosDayByDay = response.data.turnosDayByDay;

            vm.mostrarTurnos = false;
            console.log("Lista de turnos obtenida:", vm.list);
            console.log("businessName obtenido:", vm.businessName);
            console.log("createdDateByHash obtenida:", vm.createdDateByHash);
            console.log("datefrom obtenida:", vm.datefrom);
            console.log("dateto obtenida:", vm.dateto);
            console.log("idBusiness obtenida:", vm.idBusiness);
            console.log("idTpv obtenido:", vm.idTpv);
            console.log("listTurnos obtenida:", listaTurnosDayByDay);

            // Ahora que createdDateByHash tiene el valor del timestamp del momento en que fue creado el external link, ponemos llamar a checkLinkExpiration()
            // que comprueba si ha pasado más de X tiempo desde el timestamp hasta ahora. 
            vm.checkLinkExpiration();

            /*

            // Asignar valores a los atributos de clase a partir de la respuesta del GET del componente
            vm.idBusiness = data.idBusiness;
            vm.idTpv = data.idTpv;
            vm.createdDateByHash = data.createdDate;
            vm.datefrom = moment.unix(data.initDate).format("YYYY-MM-DDTHH:mm:ss.SSSZ");
            vm.dateto = moment.unix(data.endDate).format("YYYY-MM-DDTHH:mm:ss.SSSZ");
            vm.idBusinessByHash = data.idBusiness;
            vm.idTpvByHash = data.idTpv;

            
            // Por último llamamos a getBusiness, que obtendra...
            vm.getBusiness();
            */
          } else {
            console.error("Error en la respuesta:", response.data.message);
            swal({
              title: vm.$t("ups"),
              text: vm.$t("errorComunicacionBackend"),
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        })
        .catch(function (error) {
          console.error("Error al obtener datos por hash:", error);
        })
    },

    checkLinkExpiration() {
      const now = Math.floor(Date.now() / 1000); // Timestamp actual en segundos
      const timeDifference = now - this.createdDateByHash; // Diferencia en segundos

      if (timeDifference > 86400) { // 3600 = 1h | 86400 = 24h
        this.isLinkExpired = true; // Marca el enlace como caducado
        swal({
          title: this.$t("enlaceExternoTurnosCaducadoTitle"),
          text: this.$t("enlaceExternoTurnosCaducadoLabel"),
          icon: "error",
          showConfirmButton: false,
          allowOutsideClick: false,
          width: "35%",
          allowEscapeKey: false,
          className: "swal-link-expired",
          type: "info",
          backdrop: `
            rgba(0,0,0,0.95)
            url("https://i.gifer.com/YCZH.gif") 
            center no-repeat
          `,
        });
      }
    },
    /*
    filterTpvListByIdTpv(){
      this.listTpv = this.listTpv.filter((tpv) => tpv.id === this.idTpvByHash);
    },*/
  },
};
</script>

<style scoped>
.external-layout nav {
  display: none;
}

a li {
  color: #111;
}

.card {
  padding: 20px;
}

.div-export {
  margin-bottom: 10px;
}

.textNumier {
  color: #1E22AA;
}

.centered-container {
  padding: 1rem;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: top;
  text-align: center;
  background-color: #f5f5f5;
}

.external-layout {
  width: 80%;
  padding: 20px;
  background-color: white;
  border-radius: 10px;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
}

@media (max-width: 768px) {
  .rs-btn {
    width: 100%;
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/Informes/Operarios/TurnosOperariosExternalLink.vue